import './AccessWrapper.css';

import { useEffect, useState } from 'react';
import { Card, Spinner } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import User from 'utils/user.util';
import { useTranslation } from 'react-i18next';

const PRIVATE_ROUTES = [
    { route: 'giftcardinventory', permissionsPage: 'giftcardinventory' },
    { route: 'unification', permissionsPage: 'unification' },
    { route: 'b2brewards', permissionsPage: 'b2brewards' },
    { route: 'campaigntrigger', permissionsPage: 'campaigntrigger' },
    { route: 'settings', permissionsPage: 'settings' },
    { route: 'settings/users', permissionsPage: 'settings' },
    { route: 'settings/blocked-emails', permissionsPage: 'settings' },
];

const AccessWrapper = ({ children }) => {
    const { t } = useTranslation();
    const location = useLocation();
    const [hasPermission, setHasPermission] = useState(false);
    const [permissionDenied, setPermissionDenied] = useState(false);

    const getPermissionStatus = () => {
        let status;
        if (permissionDenied) {
            status = t('no_access');
        } else {
            status = (
                <>
                    <p>{t('checking_permissions')}</p>
                    <Spinner />
                </>
            );
        }

        return <div className="permission-loader">{status}</div>;
    };

    useEffect(() => {
        setHasPermission(false);
    }, [location]);

    useEffect(() => {
        const path = location.pathname.substring(1);
        const privateRoute = PRIVATE_ROUTES.find((privateRoute) => privateRoute.route === path);
        if (privateRoute) {
            User.canViewPage(privateRoute.permissionsPage).then((access) => {
                if (access.permission) {
                    setHasPermission(true);
                } else {
                    setPermissionDenied(true);
                }
            });
        } else {
            setHasPermission(true);
        }
    }, [location]);

    return (
        <div className="container access-wrapper">
            <Card body className="access-wrapper-card">
                {hasPermission ? children : getPermissionStatus()}
            </Card>
        </div>
    );
};

export default AccessWrapper;
